import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from '@mui/material';
import { ILegalTransactionRelationshipDataPurchaseContractV1 } from '../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipData';

interface IProps {
  data: ILegalTransactionRelationshipDataPurchaseContractV1;
  updateRelationshipData: (
    newValue: ILegalTransactionRelationshipDataPurchaseContractV1
  ) => void;
}

const CLAUSE_YES = 1;
const CLAUSE_NO = 2;

export const BrokerClause = ({ updateRelationshipData, data }: IProps) => (
  <>
    <Typography variant='h6' sx={{ mt: 5, mb: 2 }}>
      Maklerklausel
    </Typography>
    <FormControl fullWidth size='small'>
      <InputLabel>Maklerklausel</InputLabel>
      <Select
        label='Maklerklausel'
        value={data.withThirdPartyClause ? CLAUSE_YES : CLAUSE_NO}
        onChange={({ target: { value } }: SelectChangeEvent<number>) => {
          const newValue = Number(value);
          updateRelationshipData({
            ...data,
            withThirdPartyClause: newValue === CLAUSE_YES,
            // Reset text only when switching to "No"
            ...(newValue === CLAUSE_NO && {
              ThirdPartyClauseText: null,
            }),
          });
        }}
      >
        <MenuItem value={CLAUSE_YES}>Ja</MenuItem>
        <MenuItem value={CLAUSE_NO}>Nein</MenuItem>
      </Select>
    </FormControl>
    {data.withThirdPartyClause && (
      <TextField
        sx={{ mt: 2 }}
        label='Maklerklausel'
        value={data.ThirdPartyClauseText ?? ''}
        fullWidth
        size='small'
        multiline
        rows={5}
        onChange={({
          target: { value },
        }: React.ChangeEvent<HTMLInputElement>) =>
          updateRelationshipData({
            ...data,
            ThirdPartyClauseText: value || null,
          })
        }
      />
    )}
  </>
);
